<template>
    <v-container fluid>
        <v-dialog v-model="sampleSetDialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <sample-set-form v-model="editedSampleSet" :filter="sampleSetFilter" @cancel="sampleSetDialog = false" @open="sampleSetDialog = true" @input="onInput()" @delete="onInput()" :key="key" />
        </v-dialog>
        <v-dialog v-model="sampleSetTestDialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <sample-set-test-form v-model="editedSampleSetTest" :filter="sampleSetTestFilter" @cancel="sampleSetTestDialog = false" @open="sampleSetTestDialog = true" @input="onInput()" @delete="onInput()" :key="key" />
        </v-dialog>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col>
                        Sample Sets
                    </v-col>
                    <v-col>
                        <v-btn v-if="canEdit('SampleSets')" color="primary" class="float-right" dark @click="sampleSetDialog = true">Add SampleSet</v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <div class="align-top justify-top" style="overflow-x: auto; white-space: nowrap">
                            <sample-set v-for="sampleSet in sampleSets"
                                   :key="sampleSet.id"
                                   :sample-set="sampleSet"
                                   :sample-set-tests="sampleSet.items"
                                   @move="onMove"
                                   @add="onAdd"
                                   @edit="onEdit" />
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from "axios"
    import bucketPageService from "@/services/bucketPageService"

    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            sampleSetForm: () => import('../../forms/SampleSetForm'),
            sampleSetTestForm: () => import('../../forms/SampleSetTestForm'),
            sampleSet: () => import('./SampleSet')
        },
        data() {
            return {
                sampleSets: [],

                editedSampleSet: null,
                sampleSetFilter: {},
                sampleSetDialog: false,
                key: 0,

                editedSampleSetTest: null,
                sampleSetTestFilter: {},
                sampleSetTestDialog: false,
            }
        },
        async mounted() {
            await this.load();
        },
        methods: {
            async load() {
                this.sampleSets = await bucketPageService.getSampleSetsWithTests();
            },
            async onMove(event) {
                let sampleSetTest = event.sampleSetTest;
                sampleSetTest.sampleSetId = event.sampleSetId;

                try {
                    await axios.put("/api/SampleSetTests", sampleSetTest);
                }
                finally {
                    await this.load();
                }
            },
            onAdd(sampleSetId) {
                this.editedSampleSetTest = null;
                this.editedSampleSet = null;
                this.key++;
                this.sampleSetTestFilter = { ...this.filter, sampleSetId };
                this.sampleSetTestDialog = true;
            },
            onEdit(sampleSetTest) {
                this.editedSampleSetTest = sampleSetTest;
                this.sampleSetTestDialog = true;
            },
            async onInput() {
                this.editedSampleSetTest = null;
                this.editedSampleSet = null;
                this.sampleSetDialog = false;
                this.sampleSetTestDialog = false;
                this.key++;
                await this.load();
            }
        },
        watch: {
            $route() {
                this.load();
            }
        }
    };
</script>
